import {useTranslation} from 'react-i18next'

const VariableNote = ({
 variables,
}: {
 variables: {label: string; value: string}[]
}) => {
 const {t} = useTranslation()
 return (
  <div className='bg-[#F5F8FA] rounded-lg px-4 py-3 text-sm text-[#33393D]'>
   <p className='mb-1 text-[18px] font-medium'>
    {t('createPromotion.variableNote')}
   </p>
   <div className='flex flex-wrap gap-x-3 text-[#5A6066]'>
    {variables.map((item, index) => (
     <div key={index} className='flex items-center'>
      <span>
       {item.label}: {item.value}
      </span>
      {index !== variables.length - 1 && (
       <span className='mx-4 text-[#CED8E0]'>|</span>
      )}
     </div>
    ))}
   </div>
  </div>
 )
}

export default VariableNote
